export interface BatchCollectionMgmtRemovalListRequest {
  processDateFrom: string
  processDateTo: string
  holdingBranch: string
  removeReason: string
  isOutputList: boolean
  isOutputStatistics: boolean
  rdoOutputOrder: string
  memo: string
  batchType: string
}

export function BatchCollectionMgmtRemovalListRequestToJSON(
  value: BatchCollectionMgmtRemovalListRequest
): any {
  return {
    process_date_from: value.processDateFrom,
    process_date_to: value.processDateTo,
    holding_branch: value.holdingBranch,
    remove_reason: value.removeReason,
    is_output_list: value.isOutputList,
    is_output_statistics: value.isOutputStatistics,
    rdo_output_order: value.rdoOutputOrder,
    memo: value.memo,
    batch_type: value.batchType
  }
}
